'use strict';

var currentMenuDOM

var resetHover = function(){
  if (currentMenuDOM) {
    closeMenu(currentMenuDOM)
  }
}

document.addEventListener('click', function (e) {
  var menuDOM = e.target.closest('.header-sub-menu');

  // Open Menu
  if(menuDOM) {
    if (menuDOM == currentMenuDOM) {
      // Clicking on the current menu
      // Toggle
      closeMenu(currentMenuDOM)
    } else {
      // Not the current menu
      // Close the menu if open
      if (currentMenuDOM) {
        closeMenu(currentMenuDOM)
      }

      // Create the menu - wait a frame before creating the menu to allow other events to handle click event
      window.requestAnimationFrame(function(){
        createMenu(menuDOM)
        currentMenuDOM = menuDOM;
      })
    }
  } else {
    // Click outside of the menus
    // Close the menu
    if (currentMenuDOM) {
      closeMenu(currentMenuDOM)
    }
  }

}, true)

var closeMenu = function(menuDOM) {
  var openMenu = menuDOM.querySelector('.menu-pop')
  openMenu && openMenu.classList.remove('menu-pop')
  if(menuDOM && menuDOM.dataset.menuHighlight){
    var svg = menuDOM.querySelector('svg')
    svg.classList.remove('hover')
  }

  if (menuDOM.querySelector('.open-menu')) {
    var action = menuDOM.dataset.animation;
    if (action) {
      var menu = target.querySelector('ul')
      menu.classList.remove(action);
    }
    if (menuDOM.dataset.menuHighlight) {
      menuDOM.querySelector('svg').classList.remove('hover')
    }
  }

  if (menuDOM.getAttribute('aria-expanded') == 'true') {
    menuDOM.setAttribute('aria-expanded', false)
  }

  currentMenuDOM = null
}

function createMenu(target) {
  var menuDOM = target.closest('.header-sub-menu');
  if(menuDOM && menuDOM.dataset.menuHighlight){
    var svg = menuDOM.querySelector('svg')
    svg.classList.add('hover')
  }

  var action = target.dataset.animation;
  if (action) {
    var menu = target.querySelector('ul');
    if(menu) {
      menu.classList.add(action);
    }
  }
  if (menuDOM.getAttribute('aria-expanded') != 'true') {
    menuDOM.setAttribute('aria-expanded', true)
  }
}

module.exports = {
  resetHover: resetHover,
  closeMenu: resetHover
}
